import {useStore} from './useStore';

export const useProductComponentsFilterCount = () : number => {
    const filters = useStore( store => store.ui.productComponents);

    let activeFilterCount = 0;
    if (filters.searchFilter) {
        activeFilterCount++;
    }

    return activeFilterCount;
}